import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { GetIMEIExcelDataRequest, GetProductsClickReportDataRequest } from '../models'

export class GetProductsClickReportDataApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'excel/imeiList',
      requesterInfo,
    })
  }

  public async getReportData(request: GetIMEIExcelDataRequest): Promise<any[]> {
    return await this.postAsync<any[]>(request)
  }
}
